import { createContext, useContext, useMemo, useState } from "react";
import { todayIST } from "@/lib/format";
import { useCrmStore, useLeadActions } from "./useCrmStore";

const DataContext = createContext(null);
export const useData = () => useContext(DataContext);

export function DataProvider({ children }) {
  const { reps, leads, loading, load, leadsRef, setLeads, upsertLead, removeLead, upsertRep } = useCrmStore();
  const [editingId, setEditingId] = useState(null);
  const [pendingLost, setPendingLost] = useState(null);
  const { commitMove, moveLead, touchLead } = useLeadActions({ leadsRef, setLeads, upsertLead, setPendingLost });

  const repsById = useMemo(() => Object.fromEntries(reps.map((r) => [r.id, r])), [reps]);
  const today = todayIST();

  const value = {
    reps, leads, loading, load, repsById, today,
    upsertLead, removeLead, upsertRep, moveLead, commitMove, touchLead,
    editingId, openEditor: setEditingId, closeEditor: () => setEditingId(null),
    pendingLost, setPendingLost,
  };
  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
}
